module.exports = __webpack_public_path__ + "img/sign-in.8d7a0059.png";